import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getFSVersionsByOEM(locationId) {
	if (locationId) {
		const query = gql`
			query getFSVersionsByOEM($locationId: String!) {
				getFSVersionsByOEM(locationId: $locationId) {
					oemReference
					dealerCodeFS
					accountTypes {
						_id
						accountType
						accountNumber
						label
					}
					versions {
						_id
						version
						oemShort
						oemName
						currentFSVersion
						financialStatements {
							version
							pages {
								pageName
								pageNumber
								_id
							}
						}
					}
				}
			}
		`;

		const variables = {
			locationId: locationId,
		};

		try {
			const response = await apiInstance.post("/graphql", { query, variables });
			return response.data.data?.getFSVersionsByOEM;
		} catch (err) {
			errorLogger(err);
			return null;
		}
	}
}

export async function getAccountsByFSVersion(locationId, oemReference, dealerCodeFS, oemVersion, newFSVersion) {
	if (locationId) {
		const query = gql`
			query getAccountsByFSVersion(
				$locationId: String!
				$oemReference: String!
				$dealerCodeFS: String
				$oemVersion: String!
				$newFSVersion: String!
			) {
				getAccountsByFSVersion(
					locationId: $locationId
					oemReference: $oemReference
					dealerCodeFS: $dealerCodeFS
					oemVersion: $oemVersion
					newFSVersion: $newFSVersion
				) {
					oemReference
					dealerCodeFS
					versions {
						_id
						financialStatements {
							version
							pages {
								pageName
								pageNumber
								pageRelations {
									franchise
								}
								content
								_id
							}
						}
					}
				}
			}
		`;

		const variables = {
			locationId: locationId,
			oemReference: oemReference,
			oemVersion: oemVersion,
			newFSVersion: newFSVersion,
			dealerCodeFS: dealerCodeFS,
		};

		try {
			const response = await apiInstance.post("/graphql", { query, variables });
			return response.data.data?.getAccountsByFSVersion;
		} catch (err) {
			errorLogger(err);
			return null;
		}
	}
}
